import { useQuery } from '@tanstack/react-query';
import { getRawPage, getWikiPage, type WikiPageResponse } from '../api/wiki';

export type WikiSection = 'wiki' | 'raw';

export function useWikiPage(section: WikiSection, path: string) {
  return useQuery<WikiPageResponse>({
    queryKey: [section, path],
    queryFn: () => (section === 'wiki' ? getWikiPage(path) : getRawPage(path)),
    retry: false,
    enabled: path.length > 0,
  });
}
